import React from "react";
import { Link } from "react-router-dom";
import ContactForm from "../ContactFrom/ContactForm";
import icon1 from "../../images/icon/Buga/call-calling.svg";
import icon2 from "../../images/icon/Buga/icon-sms.svg";
import iconwp from "../../images/icon/Buga/wplogo.png";

const   ContactSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div>
      <div className="contact pt-85">
        <div className="container">
          <div className="row pb-130 mt-none-30">
            <div className="col-lg-8 mt-30">
              <div className="cs-contact-wrap cs-contact-form cd-contact-form item-contact_form">
                <h2 className="xb-title">Send us a message</h2>
                <p className="xb-content">
                  Give us a chance to serve and bring magic to your brand.
                </p>
                <ContactForm />
              </div>
            </div>
            <div className="col-lg-4 mt-30">
              <div className="item-contact_info">
                <div className="xb-item--inner">
                  <div className="xb-item--top">
                    <h3 className="xb-item--title">Contact Info</h3>
                    <a
                      href="tel:+447459852485"
                      style={{ color: "#494d57", textDecoration: "none" }}
                      className="hover-yellow"
                    >
                      <span className="xb-item--hotline">
                        <img src={icon1} alt="contact" /> +44 745 985 2485
                      </span>
                    </a>
                    <a
                      href="mailto:info@bugamoney.com"
                      target="_blank"
                      style={{ color: "#494d57" }}
                      className="hover-yellow"
                    >
                      <span className="xb-item--email">
                        <img src={icon2} alt="email" /> info@bugamoney.com
                      </span>
                    </a>
                  </div>

                  <div className="contact-info_widget">
                    <h3 className="xb-title">United Kingdom Office</h3>
                    <a
                      href="https://www.google.com/maps/search/?api=1&query=175+Roding+Lane+North%2C+Woodford+Green%2C+England%2C+IG8+8NA"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#494d57" }}
                       className="hover-yellow"
                    >
                      <span className="xb-location">
                        175 Roding Lane North, Woodford Green,<br /> England, IG8 8NA
                      </span>
                    </a>
                  </div>
                  <hr className="breack-line" />
                  <div className="contact-info_widget">
                    <h3 className="xb-title">our office open time</h3>
                    <span className="xb-location">
                      Mon - Sat : 8.00-6.00 <br /> Sunday : Closed
                    </span>
                  </div>
                  <hr className="breack-line " />
                  <div className="contact-info_widget ">
                    <h3 className="xb-title">24x7 Whatsapp Service</h3>

                    <a
                       href="https://wa.me/447459852485?text=Hello%20I%20want%20to%20know%20more%20about%20your%20money%20transfer%20services"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#494d57" }}
                      className="hover-yellow"
                    >
                      <span style={{ marginRight: "10px" }}>
                        <img src={iconwp} alt="" />
                      </span>
                      <span className="wpnumber">+44 745 985 2485</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="gmap_canvas bg-light">
        <iframe title="Office Location Map" src="https://maps.google.com/maps?q=175%20Roding%20Lane%20North%2C%20Woodford%20Green%2C%20England%2C%20IG8%208NA&t=&z=15&ie=UTF8&iwloc=&output=embed"></iframe>

       
      </div>
    </div>
  );
};

export default ContactSection;
